module.exports = __webpack_public_path__ + "static/media/S4N8-3.2c261a9c.svg";